import * as React from 'react';

import { Binding } from 'core/infrastructure';
import { cloneExcept, DateUtils } from 'core/utils';
import { FormComponent } from './Form';
import { Constraint } from './Constraints';
import { TextBox, TextBoxCtor } from './TextBox';

interface Props<T> extends React.DetailedHTMLProps<React.InputHTMLAttributes<TimeBox<T>>, TimeBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string | React.ReactNode;
	rules?: Constraint | Constraint[];
	onEnterPress?: () => void;
	onValueChange?: (value: string) => void;
	boundValue?: any;
}

export class TimeBox<T> extends React.Component<Props<T>, EmptyState> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
	}

	private textBox = React.createRef<TextBox<T>>();

	getPath() {
		return this.textBox.current!.getPath();
	}

	showErrors(errors: string[]) {
		this.textBox.current!.showErrors(errors);
	}

	getValue() {
		return this.textBox.current!.getValue();
	}

	clear() {
		this.textBox.current!.clear();
	}

	render() {
		const TheTextBox: TextBoxCtor<T> = TextBox;

		const props = cloneExcept(this.props, ['ref']);
		props.rules = !props.rules ? [] : typeof props.rules === 'function' ? [props.rules] : props.rules;

		props.propertyType = 'time';
		props.type = 'text';

		props.format = (x?: Date) => !x ? '' : DateUtils.formatDate(x, 'HH:mm');

		props.placeholder = props.placeholder || 'hh:mm';

		const formatValue = (timeValue: string | undefined) => {
			if (timeValue && timeValue.length > 2 && !timeValue.includes(':')) {
				const newTimeValue = [timeValue.slice(0, 2), ':', timeValue.slice(2)].join('');
				this.textBox.current!.setState({ value: newTimeValue });
			}
		};

		const onBlur = () => {
			const timeValue = this.textBox.current!.state.value;
			formatValue(timeValue);
		};

		const onChange = (_event: React.ChangeEvent<HTMLInputElement>) => {
			const timeValue = this.textBox.current!.state.value;

			formatValue(timeValue);
			this.props.onValueChange?.(timeValue || '');
		};

		return <TheTextBox ref={this.textBox} {...props} onBlur={onBlur} onValueChange={onChange} />;
	}
}

export type TimeBoxCtor<T> = new (props: Props<T>) => TimeBox<T>;
